// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullAdminRegatta,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
  InputHtml,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
  isDiff,
} from '@vroskus/library-helpers/dist/browser';
import {
  defaultUpsertItem,
} from '../../../../helpers';

// Services
import Services from '../../../../services';

// Types
type $Props = $Translate & {
  id: string;
  item: $FullAdminRegatta;
};

type $State = {
  changed: boolean;
  value?: null | string;
};

class RegattaSponsorsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
      value: props.item.Content,
    };
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      item,
    } = this.props;

    if (isDiff(
      prevProps.item,
      item,
    )) {
      this.setState({
        value: item.Content,
      });
    }
  }

  render() {
    const {
      id,
      item,
      t,
    } = this.props;
    const {
      changed,
      value,
    } = this.state;

    return (
      <FormSection
        changed={changed}
        fields={(
          <InputHtml
            name={'Content'}
            onChange={() => this.setState({
              changed: true,
            })}
            value={value}
          />
        )}
        headerDescription={t('Free form regatta description')}
        headerIconClass={'icon-note'}
        headerTitle={t('Regatta description')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(values) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$FullAdminRegatta>({
              ...item,
              ...values,
            });

            await Services.Api.updateRegatta(params);

            this.setState({
              changed: false,
              value: item.Content,
            });
          },
        })}
        onClear={() => this.setState({
          changed: false,
        })}
      />
    );
  }
}

export default RegattaSponsorsSectionView;
